/**
 * Custom hooks for workout sessions (Epic 4)
 */
import useSWR from "swr";
import { fetcher, api } from "../lib/api";

/**
 * Hook for today's workout
 */
export function useTodayWorkout() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/client/workouts/today",
    fetcher
  );
  
  return {
    workout: data,
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Hook for workout player data
 */
export function useWorkoutPlayer(assignedWorkoutId) {
  const { data, error, isLoading, mutate } = useSWR(
    assignedWorkoutId ? `/api/client/workouts/${assignedWorkoutId}` : null,
    fetcher,
    { refreshInterval: 0 }
  );
  
  return {
    workout: data,
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Start a workout session
 */
export async function startWorkoutSession(assignedWorkoutId) {
  return api.post(`/api/client/workouts/${assignedWorkoutId}/start`, {});
}

/**
 * Log a set
 */
export async function logSet(sessionId, data) {
  return api.post(`/api/client/sessions/${sessionId}/log`, data);
}

/**
 * Finish a workout session
 */
export async function finishWorkoutSession(sessionId, data) {
  return api.post(`/api/client/sessions/${sessionId}/finish`, data);
}

/**
 * Assign workout to client (admin)
 */
export async function assignWorkout(clientId, templateId, scheduledDate) {
  return api.post(`/api/admin/clients/${clientId}/workouts`, {
    template_id: templateId,
    scheduled_date: scheduledDate,
  });
}

/**
 * Hook for client assigned workouts (admin view)
 */
export function useClientWorkouts(clientId) {
  const { data, error, isLoading, mutate } = useSWR(
    clientId ? `/api/admin/clients/${clientId}/workouts` : null,
    fetcher
  );
  
  return {
    workouts: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}
